import React from "react";
import { compose, graphql } from "react-apollo";
import AlertModal from "components/AlertModal/AlertModal";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import {
  NavbarButton,
} from "../navbarComponents";

import { MIGRATE_SHIPMENTS_REPORTS_MUTATION } from "./mutations";

const ShipmentReportNavbar = ({
  migrateShipmentsReports,
  snackbarContext,
}) => {
  const handleMigrateShipments = async () => {
    try {
      await migrateShipmentsReports();

      snackbarContext.setNotificationTimeOut(
        Color.success,
        "Migração concluída."
      );
    } catch (error) {
      snackbarContext.setNotificationTimeOut(
        Color.danger,
        error.detail
      );
    }
  };

  const handleMigrateDialog = () => {
    AlertModal.fire({
      title: "Migrar carregamentos para o reports",
      html: "Deseja migrar os carregamentos?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#1D84C6",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Voltar",
      reverseButtons: true,
    }).then(({ value }) => {
      if (value) {
        handleMigrateShipments();
      }
    });
  };

  return (
    <React.Fragment>
      <NavbarButton onClick={() => handleMigrateDialog()} color="info" breakpoint={444}>
        Migrar Carregamentos
      </NavbarButton>
    </React.Fragment>
  );
};

export default compose(
  graphql(MIGRATE_SHIPMENTS_REPORTS_MUTATION, { name: "migrateShipmentsReports", }),
  withSnackbarConsumer,
)(ShipmentReportNavbar);
